import Slide from "./libs/slideToggle"

/**
 * FAQ Component
 *
 * @constructor
 */

export default function()
{
    const questions = document.getElementById('questions')

    if(!questions) return

    const triggers = questions.querySelectorAll('h4')

    triggers.forEach(function(trigger){
        trigger.addEventListener('click', function(event){
            Slide.toggle(this.nextElementSibling, 200)
        })
    })

}
